import { createContext, useContext } from "react";
import { MapEditorSelectionState } from "./MapEditorContext.types";

export const MapEditorSelectionContext =
  createContext<MapEditorSelectionState | null>(null);

export const useMapEditorSelection = (): MapEditorSelectionState => {
  const context = useContext(MapEditorSelectionContext);
  if (!context) {
    throw new Error(
      "useMapEditorSelection must be used within a MapEditorProvider"
    );
  }
  return context;
};
